import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Drawer, LoadingOverlay, Modal, ScrollArea } from '@mantine/core';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { Empty, Pagination, Table } from 'antd';
import useDevice from 'hooks/useDevice';
import { getTransactionPointHistory } from 'model/services/LoyaltyGiftService';
import moment from 'moment';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { formatTimeString, format_curency } from 'utils';
import { TableContractStyled } from './style';

const TablePointModal = ({ point, opened, handleOpened }) => {
  // @ts-ignore
  const profileUser = useSelector((state) => state.LoyaltyAccountInfoReducer.profilebyc);
  const { isMobile } = useDevice();
  const [dateSearch, setDateSearch] = useState({
    from: new Date(new Date(new Date().setHours(0, 0, 0, 0)).setMonth(new Date().getMonth() - 3)),
    to: new Date(),
  });
  const [firstTime, setFirstTime] = useState(true);
  const [listTransaction, setListTransaction] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const columns = [
    {
      title: '#',
      key: 'index',
      dataIndex: 'index',
      width: '7%',
    },
    {
      title: 'Giao dịch',
      key: 'contract',
      dataIndex: 'contract',
      // width: '35%',
    },
    {
      title: 'Ngày giao dịch',
      key: 'createDate',
      dataIndex: 'createDate',
      width: '20%',
    },
    {
      title: 'Hiệu lực đến',
      key: 'expirationDate',
      dataIndex: 'expirationDate',
      width: '20%',
      render: (text, record) => {
        return record.contract !== 'Đổi quà' ? <p>{text}</p> : null;
      },
    },
    {
      title: 'Trạng thái',
      key: 'status',
      dataIndex: 'status',
      width: '20%',
      render: (text, record) =>
        Number(text) > 0 ? (
          <p className='text-009565'>+{format_curency(text)}</p>
        ) : (
          <p className='text-D81221'>{format_curency(text)}</p>
        ),
    },
  ];
  const handleRows = () => {
    if (listTransaction.length > 0) {
      return listTransaction.map((trans, index) => {
        const { transaction } = trans;
        const { date, month, year } = formatTimeString(transaction.creationTime);
        const exp = transaction.expirationMonth;
        let stringExp = '---';
        if (Number(exp)) {
          stringExp = `${exp.slice(exp.length - 2, exp.length)}/${exp.slice(0, -2)}`;
        }
        return {
          index: index + 1 + pagination.pageSize * (pagination.current - 1),
          contract: transaction.description,
          createDate: `${date}/${month}/${year}`,
          expirationDate: stringExp,
          status: transaction.coin,
        };
      });
    }
  };
  const handleChange = (value, name) => {
    setDateSearch((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleDisableDateFrom = (date) => {
    const dateCheck = new Date(moment(date).toISOString());
    if (dateCheck > dateSearch.to) {
      return true;
    } else return false;
  };
  const handleDisableDateTo = (date) => {
    const dateCheck = new Date(moment(date).toISOString());
    if (dateCheck > new Date() || dateCheck < dateSearch.from) {
      return true;
    } else return false;
  };

  const searchHistoryTransaction = () => {
    const payload = {
      from: moment(dateSearch.from).startOf('day'),
      maxResultCount: pagination.pageSize,
      memberCode: profileUser.obj.code,
      profileCode: profileUser.obj.code,
      reasonCode: '',
      skipCount: pagination.pageSize * (pagination.current - 1),
      sorting: '',
      to: moment(dateSearch.to).endOf('day'),
    };
    if (opened && profileUser.obj.code) {
      firstTime && setFirstTime(false);
      setIsLoading(true);
      getTransactionPointHistory(payload)
        .then((res) => {
          if (res.obj) {
            console.log(res.obj);
            setListTransaction(res.obj);
            setIsLoading(false);
            setPagination((prev) => {
              return {
                ...prev,
                total: res.totalRecords,
              };
            });
          }
          setIsLoading(false);
        })
        .catch((err) => setIsLoading(false));
    }
  };

  useEffect(() => {
    searchHistoryTransaction();
  }, [pagination.current, pagination.pageSize]);

  return (
    <>
      {isMobile ? (
        <Drawer
          opened={opened}
          onClose={() => handleOpened(false)}
          size='xl'
          position='right'
          withCloseButton={false}
          className='pt-4'
        >
          <div className='flex h-[75vh] flex-wrap items-center justify-between'>
            <div className='flex items-center px-5 pt-5'>
              <PlusOutlined
                onClick={() => handleOpened(false)}
                className='mr-4 cursor-pointer'
                style={{
                  color: '#000',
                  fontSize: 24,
                }}
                rotate={45}
              />
              <p className='font-averta-bold text-20px'>
                Điểm đổi quà: <span className='text-0090F0'>{format_curency(point)}</span>
              </p>
            </div>
            <div className='mt-4 flex grow items-center justify-between px-5'>
              <div className='mr-4'>
                <DatePicker
                  label='Từ ngày'
                  inputFormat='DD/MM/YYYY'
                  shouldDisableDate={handleDisableDateFrom}
                  value={dateSearch.from}
                  onChange={(value) => handleChange(value, 'from')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        '.MuiInputBase-root': { color: '#434343' },
                        '.MuiOutlinedInput-input': { padding: '11px' },
                      }}
                    />
                  )}
                  components={{
                    OpenPickerIcon: CalendarMonthIcon,
                  }}
                />
              </div>
              <div className=''>
                <DatePicker
                  label='Đến ngày'
                  inputFormat='DD/MM/YYYY'
                  value={dateSearch.to}
                  shouldDisableDate={handleDisableDateTo}
                  onChange={(value) => handleChange(value, 'to')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        '.MuiInputBase-root': { color: '#434343' },
                        '.MuiOutlinedInput-input': { padding: '11px' },
                      }}
                    />
                  )}
                  components={{
                    OpenPickerIcon: CalendarMonthIcon,
                  }}
                />
              </div>
            </div>
            <div
              className='mx-5 my-4 w-full cursor-pointer rounded-md border py-3 drop-shadow-md'
              style={{
                backgroundImage: 'linear-gradient(#00AFE5, #0090F0)',
              }}
              onClick={() => searchHistoryTransaction()}
            >
              <p className='text-center font-averta-regular text-14px uppercase text-white'>
                Tìm kiếm
              </p>
            </div>
            <div className='h-[calc(100%_-_70px)] w-full overflow-scroll bg-[#F1F4FB] pt-2'>
              {listTransaction.length > 0 ? (
                listTransaction.map((trans, index) => {
                  const { transaction } = trans;
                  const { date, month, year } = formatTimeString(transaction.creationTime);
                  const exp = transaction.expirationMonth;
                  let stringExp = '---';
                  if (Number(exp)) {
                    stringExp = `${exp.slice(exp.length - 2, exp.length)}/${exp.slice(0, -2)}`;
                  }
                  return (
                    <div key={index} className='mb-1 w-full bg-white py-4 pl-6 pr-[14px]'>
                      <div className='flex justify-between font-roboto-regular'>
                        <p className='line-clamp-1 text-base'>{transaction.description}</p>
                        <p
                          className={`text-14px ${
                            Number(transaction.coin) > 0 ? 'text-009565' : 'text-D81221'
                          }`}
                        >
                          {Number(transaction.coin) > 0 ? `+${transaction.coin}` : transaction.coin}
                        </p>
                      </div>
                      <div className='flex items-center justify-start text-7B7B7B'>
                        <span>Ngày GD: {`${date}/${month}/${year}`}</span>
                        <span className='mx-1 h-3 w-px bg-D9D9D9'></span>
                        <span>Hiệu lực đến: {stringExp}</span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <>
                  <Empty description={false} />
                  <p className='mx-auto w-fit font-roboto-regular text-14px'>
                    {firstTime === true
                      ? 'Vui lòng chọn khoảng thời gian cần tra cứu'
                      : 'Không có dữ liệu'}
                  </p>
                </>
              )}
            </div>
            {listTransaction.length > 0 && (
              <div className='mb-4 mt-2 flex w-full justify-center'>
                <Pagination
                  total={pagination.total}
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  onChange={(page, pageSize) => {
                    setPagination((prev) => {
                      return {
                        ...prev,
                        pageSize: pageSize,
                        current: page,
                      };
                    });
                  }}
                />
              </div>
            )}
          </div>
          <LoadingOverlay visible={isLoading} />
        </Drawer>
      ) : (
        <Modal
          opened={opened}
          onClose={() => handleOpened(false)}
          size={'xl'}
          centered
          withCloseButton={false}
          radius={8}
          padding={0}
        >
          <div className='flex flex-wrap items-center justify-between p-5'>
            <p className='font-averta-bold text-18px'>
              Điểm đổi quà: <span className='text-0090F0'>{format_curency(point)}</span>
            </p>
            <div className='flex items-center justify-between'>
              <div className='mr-4'>
                <DatePicker
                  label='Từ ngày'
                  inputFormat='DD/MM/YYYY'
                  value={dateSearch.from}
                  shouldDisableDate={handleDisableDateFrom}
                  onChange={(value) => handleChange(value, 'from')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        '.MuiInputBase-root': { width: 154, color: '#434343' },
                        '.MuiOutlinedInput-input': { padding: '11px' },
                      }}
                    />
                  )}
                  components={{
                    OpenPickerIcon: CalendarMonthIcon,
                  }}
                />
              </div>
              <div className='mr-4'>
                <DatePicker
                  label='Đến ngày'
                  inputFormat='DD/MM/YYYY'
                  value={dateSearch.to}
                  shouldDisableDate={handleDisableDateTo}
                  onChange={(value) => handleChange(value, 'to')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        '.MuiInputBase-root': { width: 154, color: '#434343' },
                        '.MuiOutlinedInput-input': { padding: '11px' },
                      }}
                    />
                  )}
                  components={{
                    OpenPickerIcon: CalendarMonthIcon,
                  }}
                />
              </div>
              <div
                className='m-2 ml-0 w-fit cursor-pointer rounded-md p-px'
                style={{
                  backgroundImage: 'linear-gradient(#00AFE5, #0090F0)',
                }}
                onClick={() => searchHistoryTransaction()}
              >
                <SearchOutlined
                  className='m-2'
                  style={{
                    color: '#fff',
                    fontSize: 24,
                  }}
                  alt='Tìm kiếm'
                />
              </div>
              <PlusOutlined
                onClick={() => handleOpened(false)}
                className='m-2 ml-4 mr-0 cursor-pointer'
                style={{
                  color: '#000',
                  fontSize: 24,
                }}
                rotate={45}
              />
            </div>
          </div>
          <ScrollArea style={{ height: '500px' }}>
            <TableContractStyled>
              <Table
                className='min-h-[430px]'
                columns={columns}
                dataSource={handleRows()}
                locale={{
                  emptyText: (
                    <>
                      <Empty description={false} />
                      <p className='mx-auto w-fit font-roboto-thin text-14px'>
                        {firstTime === true
                          ? 'Vui lòng chọn khoảng thời gian cần tra cứu'
                          : 'Không có dữ liệu'}
                      </p>
                    </>
                  ),
                }}
                pagination={false}
                loading={isLoading}
              />
            </TableContractStyled>
          </ScrollArea>
          {listTransaction.length > 0 && (
            <div className='mb-4 mt-2 flex justify-center'>
              <Pagination
                total={pagination.total}
                current={pagination.current}
                pageSize={pagination.pageSize}
                showSizeChanger={true}
                onChange={(page, pageSize) => {
                  setPagination((prev) => {
                    return {
                      ...prev,
                      pageSize: pageSize,
                      current: page,
                    };
                  });
                }}
              />
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default TablePointModal;
